import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { parseJSONfromText } from "../../author/hooks/useImportPlans"; // Adjust the import path as necessary
import Dialog from "../../../common/Dialog";
import Loading from "../../Loading";
import Checkbox from "../../../common/Checkbox";
import TextInputForVision from "./TextInputForVision";
import { useFormikContext } from "formik";
import { Action } from "../../../../types/ActionType";
import { DayPlan } from "../../../../types/DayPlan";

const ImportDayPlan = ({
  habitId,
  setDayPlans,
  prevDayPlans,
}: {
  habitId: string;
  setDayPlans: (plans: DayPlan[]) => void;
  prevDayPlans: DayPlan[];
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState<DayPlan[] | null>(null);
  const [isJSONImport, setIsJSONImport] = useState(false);

  const parseDataToDayPlans = (rawData: any): DayPlan[] => {
    if (!rawData) {
      console.log("No data to parse");
      return [];
    }

    return rawData.map((item: any) => {
      const dayPlan: DayPlan = {
        id: item.id || "",
        createdAt: new Date().toISOString(),
        title: item.title || "",
        description: item.description || "",
        steps: Array.isArray(item.steps) ? item.steps : [],
        isCompleted: item.isCompleted || false,
        planID: item.planID || "",
        position: item.position || 0,
        communityId: item.communityId || "",
        isActive: item.isActive || true,
        authorID: item.authorID || "",
      };

      return dayPlan;
    });
  };

  const updateFormikDayPlans = () => {
    if (!data) return;

    const parsedDayPlans = parseDataToDayPlans(data);
    const updatedDayPlans = [...prevDayPlans, ...parsedDayPlans];
    setDayPlans(updatedDayPlans);
    setShow(false);
  };

  const toggleJSONImport = () => {
    setIsJSONImport(!isJSONImport);
  };

  const handleTextToUpload = async (text: string) => {
    setIsLoading(true);
    console.log("TextToBeUploaded", text);
    let plansFormat;

    plansFormat = parseJSONfromText(text);

    setData(plansFormat);
    setIsLoading(false);
    console.log("PlansFormat", plansFormat);
  };

  function generatePlanPrompt(extractedText: string) {
    return `
      Please format the following information into a JSON array of day plans.
      
      Ensure to extract and include all relevant details, even if they are spread across multiple pages.
      
      The JSON structure should be as follows:
      
      [
        {
          id: string,
          createdAt: string,
          title: string,
          description: string,
          steps: [
            {
              id: string,
              description: string,
              duration?: number,
              isCompleted?: boolean
            }
          ],
          isCompleted?: boolean,
          planID: string,
          position: number,
          communityId: string,
          isActive?: boolean,
          authorID?: string
        }
      ]
      
      Here is the extracted text:
      
      ${extractedText}
      
      Please format the extracted text into the corresponding JSON structure, ensuring that all relevant details are included and nothing is omitted:
    `;
  }

  return (
    <div>
      <Button
        style={{ marginTop: 8 }}
        color="primary"
        variant="outlined"
        onClick={() => setShow(true)}
      >
        Import Day Plans
      </Button>
      <Dialog
        positiveAction={updateFormikDayPlans}
        negativeAction={() => setShow(false)}
        onCloseDialog={() => setShow(false)}
        positiveText="Finish"
        negativeText="Cancel"
        description=""
        title="Import Day Plan"
        isOpen={show}
        ExtraButton={
          !isLoading ? (
            <div>
              <Checkbox
                checked={isJSONImport}
                onChange={toggleJSONImport}
                label="Import as JSON"
              />
              <TextInputForVision
                placeholder={`Import JSON`}
                onTextExtracted={handleTextToUpload}
              />
            </div>
          ) : (
            <Loading />
          )
        }
      />
    </div>
  );
};

export default ImportDayPlan;
